import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onRegisterPublic } from 'redux/actions/auth.actions';

import LayoutContainer from 'containers/LayoutContainer';
import RegisterView from 'views/RegisterView';
import Loading from 'components/commons/Loading';
import { IRegisterFormData } from 'views/RegisterView/types';

import 'views/RegisterView/i18n';

const ProceduresRegisterContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const loading = useTypedSelector((state) => state.auth.loading);

  const handleRegisterSubmit = (values: IRegisterFormData) => {
    dispatch(onRegisterPublic(values));
  };

  return (
    <LayoutContainer title={i18next.t<string>('REGISTER_VIEW:TITLE')}>
      <RegisterView onSubmit={handleRegisterSubmit} />
      {loading && <Loading isModalMode message={i18next.t<string>('REGISTER_VIEW:LOADING')} />}
    </LayoutContainer>
  );
};

export default ProceduresRegisterContainer;
